import { useState } from "react";
import { NXDelete, NXEditPen, NXEyes } from "../../../icons";
import useApi from "../../../api";
import { useDeleteConfirmation } from "../../common";
import { useDispatch } from "react-redux";
import { fetchTaxClass } from "../../../redux/taxClassSlice";
import TaxClassView from "./TaxClassView";
import TaxClassForm from "./TaxClassForm";
import GenericSelectableTable from "../../selectableTable";

function TaxClassTable({ data }: { data: any }) {
  const api = useApi();
  const { handleDelete } = useDeleteConfirmation();
  const dispatch = useDispatch();

  const [edit, setEdit] = useState<any>(null)
  const [taxClassId, setTaxClassId] = useState<any>(null)

  const getTaxClass = () => {
    dispatch(fetchTaxClass() as any);
  };

  const columns = [
    { header: "ID", key: "id"},
    { header: "Name", key: "name"},
    { header: "Action", key: "", render: (item: any)=>(
      <div className="flex gap-1 items-center">
        <button onClick={() => setTaxClassId(item.id)}>
          <NXEyes className="text-primary-400" />
        </button>
        <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.id,
              "Tax Class",
              api.deleteTaxClass,
              getTaxClass
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
        <button className="p-1" onClick={(e: any) => setEdit(item)}>
          <NXEditPen />
        </button>
      </div>
    )}
  ]



  return (
    <div className="mt-5">
      
      <GenericSelectableTable columns={columns} data={data}/>
      
      { taxClassId && <TaxClassView id={taxClassId} isOpen={taxClassId ? true : false} onClose={()=>setTaxClassId(null)}/>}
      { edit && <TaxClassForm edit={edit} isOpen={edit ? true : false} onClose={()=>setEdit(null)}/> }
    </div>
  );
}

export default TaxClassTable;
